import { useLocation, useNavigate } from "react-router-dom";

import { AdminIcon } from "@/components/admin/icon";
import { useMarketingCart } from "@/stores/marketing-cart.store";

/**
 * Pastille flottante « panier marketing » : visible dès qu'au moins un produit
 * est sélectionné, elle affiche le compteur et mène au générateur. Masquée quand
 * on est déjà sur la page du générateur.
 */
export function MarketingCartFab() {
	const count = useMarketingCart((s) => s.items.length);
	const navigate = useNavigate();
	const { pathname } = useLocation();

	if (count === 0 || pathname.startsWith("/marketing/generateur")) return null;

	return (
		<button
			type="button"
			onClick={() => navigate("/marketing/generateur")}
			title={`${count} produit(s) dans le panier marketing`}
			style={{
				position: "fixed",
				right: 20,
				bottom: 20,
				zIndex: 40,
				display: "inline-flex",
				alignItems: "center",
				gap: 8,
				padding: "11px 16px",
				borderRadius: 999,
				border: "none",
				cursor: "pointer",
				background: "var(--a-accent, #c2410c)",
				color: "#fff",
				fontWeight: 600,
				fontSize: 13,
				boxShadow: "0 6px 20px rgba(0,0,0,0.22)",
			}}
		>
			<AdminIcon n="trend" s={16} />
			Panier marketing
			<span
				style={{
					display: "inline-flex",
					alignItems: "center",
					justifyContent: "center",
					minWidth: 20,
					height: 20,
					padding: "0 6px",
					borderRadius: 999,
					background: "rgba(255,255,255,0.25)",
					fontVariantNumeric: "tabular-nums",
				}}
			>
				{count}
			</span>
		</button>
	);
}
